import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { key: 0 };
import { pStore } from '@/pinia';
import SubControllerTemplate from '@/templates/SubControllerTemplate.vue';
import { storeToRefs } from 'pinia';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SubController',
    setup(__props) {
        const pDistributorNotice = pStore.piniaDistributorNotice;
        const { isCreatePage, itemDetail, } = storeToRefs(pDistributorNotice);
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(SubControllerTemplate, null, {
                titleSlot: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(isCreatePage) ? '신규 등록' : '수정') + " ", 1 /* TEXT */),
                    (!_unref(isCreatePage))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, " (No. " + _toDisplayString(_unref(itemDetail).id) + ") ", 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
